export default "__VITE_ASSET__93d74e48__"